import { USER_ROUTES as userRoutes } from "~/api/routes";

export const state = () => ({
  users: [],
  details:null,
  close:false,
  isRequesting:false
});

export const getters = {};

export const mutations = {
  USERS_LOAD(state) {
    //state.isLoading = true;
    state.hasError = false;
    state.users = [];
    //state.page = page;
  },
  USERS_SUCCES(state, users) {
    state.users = users;
    //state.pagination = params.payload.pagination;
    //state.filters = params.filters || state.filters;
  },
  USERS_ERROR(state) {
    state.users = [];
    state.hasError = true;
  },
  USERS_LOADED(state) {
    //state.isLoading = false;
  },
  USER_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  USER_PROCESSING_END(state) {
    //state.isLoading = false;
  },
  CLOSE_MODAL(state,close){
    state.close = close;
  },
  IS_REQUESTING(state,isRequesting){
    state.isRequesting = isRequesting
  },
  USER_ERROR(state) {
    //state.isLoading = false;
  },
  ADD_USER_TO_LIST(state, user) {
    state.users.unshift(user);
  },
  UPDATE_A_USER(state, user) {
    let index = state.users.findIndex((elem) => elem.user_id === user.user_id);
    state.users = state.users.filter(element => element.user_id !== user.user_id);
    state.users.splice(index, 0, user);
  },
  REMOVE_USER_TO_LIST(state, user) {
    state.users = state.users.filter(element => element.user_id !== user.user_id);
  },
  USER_DETAILS_SUCCES(state, details) {
    state.details = details
    //state.isLoading = false;
  },
};

export const actions = {
  async getUsers({ commit }) {
    commit('USERS_LOAD');
    commit('IS_REQUESTING',true);
    this.$api.request(userRoutes.list)
      .then(response => {
        commit('USERS_SUCCES', response.payload);
      })
      .catch(error => {
        commit('USERS_ERROR');
      })
      .finally(() => {
        commit('USERS_LOADED');
        commit('IS_REQUESTING',false);
      });
  },
  async getUser({ commit }, params) {
    //commit('USERS_LOAD');
    this.$api.request(userRoutes.get, {id: params.user_id})
      .then(response => {
        commit('USER_DETAILS_SUCCES', response.payload);
      })
      .catch(error => {
        //commit('USERS_ERROR');
      })
      //.finally(() => commit('USERS_LOADED'));
  },
  async createUser({ commit }, params) {
    commit('USER_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(userRoutes.create, {}, params)
      .then(response => {
        //commit('USER_SUCCES', response);
        commit('CLOSE_MODAL',true);
        commit('ADD_USER_TO_LIST', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('USER_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('USER_PROCESSING_END')
      });
  },
  async updateUser({ commit }, params) {
    commit('USER_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(userRoutes.update, { id: params.user_id }, params)
      .then(response => {
        //commit('USER_SUCCES', response);
        commit('UPDATE_A_USER', response.payload);
        commit('CLOSE_MODAL',true);
      })
      .catch(error => {
        commit('USER_ERROR');
        commit('CLOSE_MODAL',false);
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('USER_PROCESSING_END')
      });
  },
  async deleteUser({ commit }, params) {
    commit('USER_PROCESSING_START');
    await this.$api.request(userRoutes.delete, { id: params.user_id })
      .then(response => {
        //commit('USER_SUCCES', response);
        commit('REMOVE_USER_TO_LIST', params);
      })
      .catch(error => {
        commit('USER_ERROR');
      })
      .finally(() => commit('USER_PROCESSING_END'));
  }
};
